export default [
  {
    path: "descuentos",
    name: "descuentos",
    component: () =>
      import(/* webpackChunkName: "gestionDescuentos" */ "./descuentos.vue"),
  },
];
